export function TI_highlight_getSelection(container) {
	let result = {
		start: null,
		length: null
	};

	if (container && window.getSelection && window.getSelection().toString().trim()) {
		// get starting node and ending node
		let selection = window.getSelection();
		let startNode = selection.anchorNode; // start of selection
		let endNode = selection.focusNode; // end of selection

		// set initial start & length
		result.start = selection.anchorOffset;
		result.length = selection.focusOffset - result.start;

		/* check if baseNode is not extentNode
		 *  - check if startNode is really is the start of selection
		 *  - increase length with elements' length between startNode & endNode
		*/
		if (selection.anchorNode !== selection.focusNode) {
			// set startnode & endnode to temp variables
			let sn = startNode;
			let en = endNode;

			// startnode is not child of container
			if (sn.parentNode !== container) {
				sn = sn.parentNode;
			}

			// endnode is not child of container
			if (en.parentNode !== container) {
				en = en.parentNode;
			}

			// get startnode & endnode child index
			let si = null, ei = null;
			container.childNodes.forEach(function (el, i) {
				if (el === sn) {
					si = i;
				}

				if (el === en) {
					ei = i;
				}
			});

			// startnode is not start of selection
			if (si > ei) {
				startNode = selection.focusNode;
				endNode = selection.anchorNode;

				result.start = selection.focusOffset;
				result.length = startNode.length - result.start + selection.anchorOffset;
			}
			else {
				result.length = startNode.length - result.start + selection.focusOffset;
			}

			// increase length with previousSiblings' length
			result.length = TI_highlight_findLengthBefore(endNode, result.length, container, startNode);
		}
		// check if the selection was made from behind and switch start & length if so
		else if (selection.anchorOffset > selection.focusOffset) {
			result.start = selection.focusOffset;
			result.length = selection.anchorOffset - result.start;
		}

		// increase start with previousSiblings' length
		result.start = TI_highlight_findLengthBefore(startNode, result.start, container);
	}

	return result;
}

export function TI_highlight_findLengthBefore(node, length, container, endInNode) {
	/* check if node is child of container
	 *  - set node to parent
	 *  - increase length with current tag's starting length e.g <strong>
	*/
	if (node.parentNode !== container) {
		node = node.parentNode;
		length += node.outerHTML.replace(/^(<[^>]+>).+$/gm, '$1').length;
	}

	// set prevNode
	let prevNode = node.previousSibling;

	// no more previous elements, break the recursive function
	if (!prevNode) {
		return length;
	}

	// we got end before node
	if (typeof endInNode !== "undefined") {
		/* check if endInNode is child of container
		 *  - set endInNode to parent
		 *  - increase length with current tag's ending length e.g </strong>
		*/
		if (endInNode.parentNode !== container) {
			endInNode = endInNode.parentNode;
			length += endInNode.outerHTML.replace(/^<[^>]+>.+(<\/.+)$/gm, '$1').length;
		}

		if (prevNode == endInNode) {
			return length;
		}
	}

	// an actual element e.g STRONG
	if (typeof prevNode.length == "undefined") {
		if (prevNode.className.substr(0, 13) == 'ti-prokontra-') {
			length += 1;
		}
		else {
			length += prevNode.outerHTML == '<br>' ? 1 : prevNode.outerHTML.length;
		}
	}
	// text node
	else {
		length += prevNode.length;
	}

	return TI_highlight_findLengthBefore(prevNode, length, container, endInNode);
}
